import axios from "axios";


export const API_URL = `${process.env.REACT_APP_API_URL}`;

export const authorization = async (email, password) => {
    try {
        const response = await axios.post(`${API_URL}/api/agent/login`, {
            email, password,
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Ошибка авторизации" };
    }
};

export const getALlDomains = async () => {
    try {
        const response = await axios.get(`${API_URL}/domains`);
        return response.data;
    }catch(error) {
        console.log(error);
    }
}